module.exports = __webpack_public_path__ + "static/img/3.d47c38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/03/4/2/3.png
// module id = B9gE
// module chunks = 2